<div class="container"
     (contextmenu)="onContextMenu($event)"
     [matTooltip]="computedTooltip()"
>
  <ng-content></ng-content>
  <app-cell-error-icon [params]="params()"></app-cell-error-icon>
</div>
